/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useIntl } from "react-intl";
import { useRouter } from "next/router";
import { useIsomorphicLayoutEffect } from "react-use";
import dynamic from "next/dynamic";
import { CXCircularProgress } from "../../common/components/CircularProgress";
import LessonDetailView from "../components/LessonDetailView";
import { quizActions } from "../redux/actions";
import { IQuizState } from "../utils/type";
import AlertDialog from "../../common/dialog/AlertDialog";
import { commonActions } from "../../common/redux/actions";
import { TCommonState } from "../../common/utils/type";
import {
  ERROR_CODE_NEED_BUY_VIP,
  ERROR_CODE_NEED_LOGIN,
  NATIVE_SURVEY_TYPE,
  getNativeOnScreen
} from "../../common/utils/constant";
import { ROUTES } from "../../../utils/configs/router";
import { eventTracking } from "../../../firebase/firebaseConfig";

const NativeSurvey = dynamic(() => import("../../common/components/NativeSurvey"), {
  ssr: false
});

function LessonDetail({ props }) {
  const { lessons } = props;
  const intl = useIntl();
  const dispatch = useDispatch();
  const location = useRouter();
  // const lessons = useSelector((state: { quizCore: { lessonData: any } }) => state.quizCore.lessonData);
  const { isLoading, notify } = useSelector((state: { quizCore: IQuizState }) => state.quizCore);
  const userInfo = useSelector((state: { commonNew: TCommonState }) => state.commonNew?.userInfos);
  const { survey } = useSelector((state: { commonNew: TCommonState }) => state.commonNew);

  const nativeSurveys = useMemo(() => {
    return getNativeOnScreen(survey, location?.pathname, location) || [];
  }, [survey, location]);

  const handleCloseNotify = () => {
    dispatch(quizActions.handleCleanNotify());
  };
  useEffect(() => {
    eventTracking("view_lessons", { id: lessons?.id, title: lessons?.title, link: lessons?.reference?.direct_link });
    if (notify?.errorCode === "") {
      handleCloseNotify();
    }
  }, []);
  useIsomorphicLayoutEffect(() => {
    location.replace(location.asPath);
  }, [userInfo?.member?.pub_id]);

  if (isLoading) {
    return <CXCircularProgress />;
  }

  return (
    <>
      <NativeSurvey currentSurvey={nativeSurveys?.find((e) => e?.location_survey?.native === NATIVE_SURVEY_TYPE.TOP)} />
      <LessonDetailView lessons={lessons} />
      <NativeSurvey
        currentSurvey={nativeSurveys?.find((e) => e?.location_survey?.native === NATIVE_SURVEY_TYPE.BOTTOM)}
      />
      {notify?.isOpenDialog && notify.message !== null && (
        <AlertDialog
          open={notify?.isOpenDialog}
          setOpen={handleCloseNotify}
          content={`${notify?.message}(${notify?.errorCode})`}
          title={intl.formatMessage({ id: "Dialog.common.title" })}
          buttonOkKey="common.ok"
          triggerFunc={() => {
            if (notify?.errorCode === ERROR_CODE_NEED_LOGIN) {
              handleCloseNotify();
              dispatch(commonActions.handleOpenModalLogin({ isOpen: true }));
            } else if (notify?.errorCode === ERROR_CODE_NEED_BUY_VIP) {
              location?.push(ROUTES.kimcuong.nangcapvip.path);
            }
            handleCloseNotify();
          }}
          isHideCancel={
            !(notify?.errorCode === ERROR_CODE_NEED_BUY_VIP || notify?.errorCode === ERROR_CODE_NEED_BUY_VIP)
          }
          cancelFunc={() => {
            handleCloseNotify();
            if (notify?.errorCode === ERROR_CODE_NEED_BUY_VIP) {
              location.back();
            } else {
              location.push("/");
            }
          }}
          notifyError
        />
      )}
    </>
  );
}

export default LessonDetail;
